import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { LoginForm } from "@/components/LoginForm";
import { Spinner } from "@/components/ui/spinner";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/login")({
  component: LoginPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      redirect: typeof search.redirect === "string" ? search.redirect : undefined,
    };
  },
});

function LoginPage() {
  const navigate = useNavigate();
  const { redirect } = Route.useSearch();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Once auth is determined and user is authenticated, redirect to intended destination
    if (!isLoading && isAuthenticated) {
      navigate({
        to: redirect || "/",
        replace: true,
      });
    }
  }, [isAuthenticated, isLoading, navigate, redirect]);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
        <Spinner size={32} />
      </div>
    );
  }

  // Show loading spinner while redirecting authenticated user
  if (isAuthenticated) {
    return (
      <div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
        <Spinner size={32} />
      </div>
    );
  }

  // Show login form for unauthenticated users
  return (
    <div className="flex min-h-svh flex-col items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm md:max-w-3xl">
        <LoginForm />
      </div>
    </div>
  );
}
